import React from 'react';
import cn from '../../lib/bem';

import './progressBar_component.scss';

const ProgressBarComponent = ({label, progress}) => {
    
    const classes = cn("progressBar");

    return (
        <div className={classes()}>
            <span data-testid={label} style={{width:`${progress}%`}}><span className={classes('progress')}></span></span>
        </div>
    )

}

export default ProgressBarComponent;








